module.exports = __webpack_public_path__ + "img/20200114160013325.94639ed3.jpg";